import React, { useState, useEffect, useRef, useMemo } from "react"
import {
  Col,
  Card,
  CardBody,
  Badge,
  Input,
  Label,
  Row,
  Button,
  UncontrolledTooltip,
  Form,
  FormFeedback,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"

import { Link } from "react-router-dom"
import { isEmpty, map } from "lodash"
import { getAdmins as onGetAdmins } from "../../store/admin/actions"
import PropTypes from "prop-types"
import { statusTypes, messageTitle, stations } from "constants/common"
import { passwordRegex } from "../../helpers/validator"
import AdminCreate from "./AdminCreate"
import {
  updateAdmin as onUpdateAdmin,
  changePasswordAdmin as onChangePasswordAdmin,
} from "../../store/admin/actions"
import DeleteModal from "components/Common/DeleteModal"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
//redux
import { useSelector, useDispatch } from "react-redux"

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { env } from '../../env'

const sizePerPage = 25

const getColor = status => {
  if (status == statusTypes.Removed || status == statusTypes.Rejected) {
    return "danger"
  } else if (
    status == statusTypes.Approved ||
    status == statusTypes.Available
  ) {
    return "success"
  } else if (status == "Not-Available") {
    return "dark"
  } else {
    return "warning"
  }
}

const checkStatus = status => {
  if (status == statusTypes.Removed || status == statusTypes.Rejected) {
    return true
  } else {
    return false
  }
}

const AdminList = props => {
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [selectedAdmin, setSelectedAdmin] = useState(null)

  // For change password section
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);

  const passwordValidation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // currentPassword: currentPassword || '',
      newPassword: newPassword || '',
      confirmPassword : confirmPassword || '',
    },
    validationSchema: Yup.object({
      // currentPassword: Yup.string()
      //   .required("Please Enter Current Password"),
      newPassword: Yup.string()
        .required("Please Enter New Password")
        .min(Number(process.env.REACT_APP_PASSWORD_MIN_LENGTH), "Must be at least "+process.env.REACT_APP_PASSWORD_MIN_LENGTH+" characters")
        .matches(passwordRegex,
          "Password must contain at least "+process.env.REACT_APP_PASSWORD_MIN_LENGTH+" characters, one uppercase, one number and one special case character"
        ),
      confirmPassword: Yup.string()
        .required("Please Enter New Password")
        .min(Number(process.env.REACT_APP_PASSWORD_MIN_LENGTH), "Must be at least "+process.env.REACT_APP_PASSWORD_MIN_LENGTH+" characters")
        .oneOf([Yup.ref('newPassword'), null], "Passwords do not match"),
    }),
  });

  const { adminList, message, error } = useSelector(state => ({
    adminList: state.admins.adminList,
    message: state.admins.message,
    error: state.admins.error,
  }))

  useEffect(() => {
    console.log("message", message, modal)
    if (message && !modal) {
      toastr.success(message, messageTitle)
    }
    if (!isEmpty(error) && !modal) {
      toastr.error(error.message, messageTitle)
    }
  }, [error,message])

  const [deleteModal, setDeleteModal] = useState(false)

  const pageOptions = {
    sizePerPage: sizePerPage,
    totalSize: adminList?.length || 1,
    custom: true,
  }
  const keyField = "_id"
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const adminListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => <>{record._id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
    },
    {
      text: "Email",
      dataField: "email",
      sort: true,
    },
    // {
    //   text: "Controls",
    //   dataField: "controls",
    //   sort: true,
    // },
    {
      text: "Status",
      dataField: "status",
      sort: true,
      formatter: (cellContent, admin) => (
        <Badge className={"bg-" + getColor(admin?.status)}>
          {admin?.status == "Approved" || admin?.status == "Available"
            ? "Live"
            : admin?.status}
        </Badge>
      ),
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      formatter: (cellContent, record) => (
        <div className="d-flex gap-3">
          <Link
            className="text-primary"
            to="#"
            style={{
              opacity: checkStatus(record?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(record?.status) ? "none" : "auto",
            }}
            id={`edittooltip_${record._id}`}
          >
            <i
              className="mdi mdi-account-edit font-size-24"
              id="updateAdmin"
              onClick={e => handleEditClick(record)}
            ></i>
            <UncontrolledTooltip placement="top" target="updateAdmin">
              Update Admin
            </UncontrolledTooltip>
          </Link>
          <Link
            className={"text-primary"}
            to="#"
            style={{
              opacity: checkStatus(record?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(record?.status) ? "none" : "auto",
            }}
            id={`edittooltip_${record._id}`}
          >
            <i
              className="mdi mdi-account-key font-size-24"
              id="changePassword"
              onClick={e => handleLiveClick(record)}
            ></i>
            <UncontrolledTooltip placement="top" target="changePassword">
              Change Password
            </UncontrolledTooltip>
          </Link>
          {!["SUPER_ADMIN","PMS"].includes(record.type) && (
            <>
              <Link
              className={record?.status == "Not-Available" ? "text-success" : "text-black"}
              to="#"
              style={{
                opacity: checkStatus(record?.status) ? "0.4" : 5,
                pointerEvents: checkStatus(record?.status) ? "none" : "auto"
              }}
              id={`edittooltip_${record._id}`}
            >
              <i
                className={record?.status == "Not-Available"
                  ? "mdi mdi-account-arrow-left font-size-24"
                  : "mdi mdi-account-cancel font-size-24"}
                id={`suspendtooltip_${record._id}`}
                onClick={e => handleBlockClick(record)}
              ></i>
              <UncontrolledTooltip placement="top" target={`suspendtooltip_${record._id}`}>
                {record?.status != "Not-Available"
                  ? "Suspend Admin"
                  : "Unsuspend Admin"}
              </UncontrolledTooltip>
              </Link>
              <Link
              className="text-danger"
              to="#"
              style={{
                opacity: checkStatus(record?.status) ? "0.4" : 5,
                pointerEvents: checkStatus(record?.status) ? "none" : "auto"
              }}
              id={`deletetooltip_${record._id}`}
            >
                <i
                  className="mdi mdi-account-minus font-size-24"
                  id="deletetooltip"
                  onClick={() => onClickDelete(record)}
                ></i>
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Remove Admin
                </UncontrolledTooltip>
              </Link>
            </>
            )
          }
          {record?.status == "Removed" && (
            <Button
              color="primary"
              className="font-16 btn-block btn btn-primary"
              onClick={() => onClickUndoRemoved(record)}
            >
              Undo Removed
            </Button>
          )}
        </div>
      ),
    },
  ]

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const onClickDelete = admin => {
    setSelectedAdmin({ ...admin, action: "Removed" })
    setDeleteModal(true)
  }

  const onClickUndoRemoved = admin => {
    setSelectedAdmin({ ...admin, action: "Approved", undoRemoved: true })
    setDeleteModal(true)
  }

  const handleBlockClick = admin => {
    if (admin?.status == "Not-Available") {
      setSelectedAdmin({ ...admin, action: "Approved" })
    } else {
      setSelectedAdmin({ ...admin, action: "Not-Available" })
    }
    setDeleteModal(true)
  }

  const handleLiveClick = admin => {
    setSelectedAdmin({ ...admin, action: "change-password" })
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (selectedAdmin.action == "change-password") {
      if (passwordValidation.isValid === false) {return}

      const updateAdmin = {
        id: selectedAdmin._id,
        email: selectedAdmin.email,
        password: passwordValidation.values.newPassword
      }
      dispatch(onChangePasswordAdmin(updateAdmin))
      passwordValidation.resetForm();
      setDeleteModal(false)
    } else {
      const updateAdmin = {
        id: selectedAdmin._id,
        status: selectedAdmin.action,
        undoRemoved: selectedAdmin.action === "Approved" ? true : false,
      }
      dispatch(onUpdateAdmin(updateAdmin))
      setDeleteModal(false)
    }
  }

  useEffect(() => {
    dispatch(onGetAdmins())
  }, [dispatch])

  const toggle = () => {
    setModal(!modal)
  }

  const handleEditClick = admin => {
    setSelectedAdmin(admin)
    toggle()
  }

  const handleAddClick = () => {
    setSelectedAdmin(null)
    toggle()
  }

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        bodyText={
          selectedAdmin?.action == "Approved"
          ? "You want to Undo Removed admin: "+ selectedAdmin?.name+"!"
          : selectedAdmin?.action == "Not-Available"
          ? "You want to Suspend admin: "+ selectedAdmin?.name+"!" 
          : selectedAdmin?.action == "Removed"
          ? "You want to Remove admin: "+ selectedAdmin?.name+"!"
          : selectedAdmin?.action == "change-password"
          ? "You want to Change Password for admin: "+ selectedAdmin?.name+"!"
          : "You want to Suspend admin: "+ selectedAdmin?.name+"!"
        }
        text={
          selectedAdmin?.action == "Not-Available"
            ? "Yes, Suspend it!"
            : selectedAdmin?.action == "Approved"
            ? "Yes, live it!"
            : selectedAdmin?.action == "Pending"
            ? "Yes, unlive it!"
            : selectedAdmin?.action == "change-password"
            ? "Yes, change password!"
            : "Yes, delete it!"
        }

        childComponent={ // For change password of admin user
          selectedAdmin?.action == "change-password" ? (
            <div>
              <h4>{"Change password for admin: "+ selectedAdmin?.name}</h4>
              <Form
                className="form-horizontal"
              >
                <div className="form-group">
                  <Label className="form-label">New Password</Label>
                  <Input
                    name="newPassword"
                    className="form-control w-50 mx-auto"
                    placeholder="Enter New Password"
                    type={passwordShown ? "text" : "password"}
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.newPassword || ""}
                    invalid={
                      passwordValidation.touched.newPassword && passwordValidation.errors.newPassword ? true : false
                    }
                  />
                  {passwordValidation.touched.newPassword && passwordValidation.errors.newPassword ? (
                    <FormFeedback type="invalid">{passwordValidation.errors.newPassword}</FormFeedback>
                  ) : null}
                </div>

                <div className="form-group">
                  <Label className="form-label pb-0">Confirm Password</Label>
                  <Input
                    name="confirmPassword"
                    className="form-control w-50 mx-auto"
                    placeholder="Confirm Password"
                    type={passwordShown ? "text" : "password"}
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.confirmPassword || ""}
                    invalid={
                      passwordValidation.touched.confirmPassword && passwordValidation.errors.confirmPassword ? true : false
                    }
                  />
                  {passwordValidation.touched.confirmPassword && passwordValidation.errors.confirmPassword ? (
                    <FormFeedback type="invalid">{passwordValidation.errors.confirmPassword}</FormFeedback>
                  ) : null}
                </div>
              </Form>
            </div>
          ) : null
        }

        icon={
          selectedAdmin?.action == "Not-Available"
            ? "mdi mdi-account-cancel"
            : selectedAdmin?.action == "Approved"
            ? "mdi mdi-account-arrow-left"
            : selectedAdmin?.action == "change-password"
            ? "mdi mdi-account-key"
            : "mdi mdi-account-minus"
        }
        iconColor={
          selectedAdmin?.action == "Not-Available"
            ? "text-black"
            : selectedAdmin?.action == "Approved"
            ? "text-success"
            : selectedAdmin?.action == "change-password"
            ? "text-primary"
            : "text-danger"
        }
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              {/* <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={adminListColumns}
                data={adminList || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    
                  )
                }}
              </PaginationProvider> */}
              <ToolkitProvider
                      keyField={keyField}
                      data={adminList || []}
                      columns={adminListColumns}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="8"></Col>
                            <Col sm="4">
                              <div className="text-sm-end">
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={handleAddClick}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add New Admin
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  // {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                />
                              </div>
                            </Col>
                          </Row>
                          {/* <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row> */}
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {modal && (
        <AdminCreate
          isOpen={modal}
          toggle={toggle}
          admin={selectedAdmin}
          history={null}
          setSelectedAdmin={setSelectedAdmin}
        />
      )}
    </React.Fragment>
  )
}

export default AdminList
AdminList.propTypes = {
  setSelectedAdmin: PropTypes.func,
  admin: PropTypes.object,
}
